import {createContext} from "react";
import {StripeCustomer} from "../utils";


export type TSessionUser = {
    name: string
    address: string
    phone: string
}


export type TSessionUserContext = {
    user: StripeCustomer | null
    polygons: any[] | null
    propertySize: number | null
    location: google.maps.GeocoderResult | null
    setUser: (user: StripeCustomer|null) => void
    setLocation: (location: google.maps.GeocoderResult) => void
    setPolygons: (polygons: any[]) => void
    setPropertySize: (area: number) => void
}
export const SessionUserContext = createContext<TSessionUserContext>({
    user: null,
    location: null,
    polygons: null,
    propertySize: null,
    setUser: (user) => {
    },
    setLocation: (location) => {
    },
    setPolygons: (polygons) => {
    },
    setPropertySize: (area: number) => {
    }

})
